export { DestinationContent } from "./destinationContent";
